import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { Team } from '@utils/api/teams/use-get-teams.tsx';

export type TeamDataResponse = BaseResponse<Team>;

export const useGetTeam = (teamId: string) => {
  const fetchTeam = async () => {
    const response = await Axios.get<TeamDataResponse>(GET_URL(teamId).team);
    return response.data.result;
  };

  return useQuery<Team, AxiosError<BaseError>>(['team', teamId], fetchTeam);
};
